import api from "../api";
import { IHearingIndexUpdate } from "./interface";

export const markingService = {
  delete: async (id: number) => {
    try {
      await api.delete(`/v1/HearingIndex/Delete?id=${id}`);
    } catch (error) {
      throw new Error("não foi possivel deletar essa marcação");
    }
  },
  update: async (item: IHearingIndexUpdate) => {
    try {
      await api.put(`/v1/HearingIndex/Update`, item);
    } catch (error) {
      throw new Error("não foi possivel atualizar essa marcação");
    }
  },
  patch: async (id: string, path: string, value: string) => {
    try {
      const replaceBody = [
        {
          op: "replace",
          value: value,
          path: path,
        },
      ];

      const { data } = await api.patch<any>(
        `/v1/HearingIndex/Update?id=${id}`,
        replaceBody,
      );

      return {
        success: true,
        body: data,
      };
    } catch (error) {
      return {
        success: false,
        body: {},
      };
    }
  },
};
